import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserDealerList from "./user-dealer-list";
import DealerListParams from "./user-dealer-list-params";

const useDealerList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserDealerList>({ data: [], totalCount: 0 });

  const load = async (
    params: DealerListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const dealerList = await userService.getDealerList(params, signal);

      setData(dealerList);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDealerList;
